import React from 'react';
import { Route, Redirect } from 'react-router-dom'
import { Auth } from '../services/Auth';
import SiteHeader from '../components/header/AuthHeader';
import MainMenu from './MainMenu';

/* Main Layout */
const MainLayout = ({ children, ...rest }) => {
  return (
    <React.Fragment>
      <SiteHeader />
      <main className='ta--flex ta--pt-60 rtl--row-reverse'>
        <MainMenu />
        <div className="ta--main-content ta-w100 ">
          {children}
        </div>
      </main>
    </React.Fragment>
  )
}

/* Private route wrapper */
export const MainLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (Auth.isAuthenticated() === true ?
      <MainLayout>
        <Component {...matchProps} />
      </MainLayout>
      : <Redirect to='/login' />
    )} />
  )
};



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js